import { get_supportsRequestBodyjdtitrt33hir as get_supportsRequestBody } from '../../../../../ktor-ktor-http/io/ktor/http/HttpMethod.mjs';
import {
  isEmpty1yq29t926r0va as isEmpty,
  ProtocolUpgradexnnpt2xliy8g as ProtocolUpgrade,
  NoContent1bdx48poqrifq as NoContent,
  ContentWrapper3n9gdymgnbto9 as ContentWrapper,
  WriteChannelContent1d7f40hsfcaxg as WriteChannelContent,
  ReadChannelContentz1amb4hnpqp4 as ReadChannelContent,
  ByteArrayContent2n0wb43y6ugs1 as ByteArrayContent,
} from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { mergeHeadersub4y73mj759y as mergeHeaders } from '../engine/Utils.mjs';
import { toTypedArray3sl1vhn8ifta0 as toTypedArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnsupportedContentTypeException1omj39t4jp3a7 as UnsupportedContentTypeException } from '../call/utils.mjs';
import { GlobalScope_instance3w3xrcgjszz2p as GlobalScope_instance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { writer1eia5its2a1fh as writer } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteWriteChannelOperations.mjs';
import { readRemaining1kbpbgdrq25q1 as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { readByteArray1ri21h2rciakw as readByteArray } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Sources.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *ktor_toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
  var jsHeaders = {};
  // Inline function 'io.ktor.client.request.forEachHeader' call
  var skipContentLengthHeader = !get_supportsRequestBody(_this__u8e3s4.i5l_1) && isEmpty(_this__u8e3s4.k5l_1);
  mergeHeaders(_this__u8e3s4.j5l_1, _this__u8e3s4.k5l_1, (key, value) => {
    var tmp;
    if (skipContentLengthHeader && key === 'Content-Length') {
      return Unit_instance;
    }
    jsHeaders[key] = value;
    return Unit_instance;
  });
  var bodyBytes = yield* getBodyBytes(_this__u8e3s4.k5l_1, callContext, $completion);
  return buildObject(($this$buildObject) => {
    $this$buildObject.method = _this__u8e3s4.i5l_1.g52_1;
    $this$buildObject.headers = jsHeaders;
    var tmp;
    if (clientConfig.e5h_1) {
      // Inline function 'org.w3c.fetch.FOLLOW' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'follow';
    } else {
      // Inline function 'org.w3c.fetch.MANUAL' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'manual';
    }
    $this$buildObject.redirect = tmp;
    var tmp0_safe_receiver = bodyBytes;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
    }
    return Unit_instance;
  });
}
function asString(_this__u8e3s4) {
  var tmp = JSON;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = ['message', 'target', 'type', 'isTrusted'];
  return tmp.stringify(_this__u8e3s4, tmp$ret$0);
}
function *getBodyBytes(content, callContext, $completion) {
  var tmp;
  if (content instanceof ByteArrayContent()) {
    tmp = content.q57();
  } else {
    if (content instanceof ReadChannelContent()) {
      tmp = readByteArray(yield* readRemaining(content.t57(), $completion));
    } else {
      if (content instanceof WriteChannelContent()) {
        var tmp_0 = GlobalScope_instance;
        tmp = readByteArray(yield* readRemaining(writer(tmp_0, callContext, VOID, getBodyBytes$slambda(content)).y4k_1, $completion));
      } else {
        if (content instanceof ContentWrapper()) {
          tmp = yield* getBodyBytes(content.z57(), callContext, $completion);
        } else {
          if (content instanceof NoContent()) {
            tmp = null;
          } else {
            if (content instanceof ProtocolUpgrade()) {
              throw UnsupportedContentTypeException().b5l(content);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
  }
  return tmp;
}
function buildObject(block) {
  // Inline function 'kotlin.apply' call
  var this_0 = {};
  block(this_0);
  return this_0;
}
function getBodyBytes$slambda($content) {
  return constructCallableReference(function *($this$writer, $completion) {
    yield* $content.v57($this$writer.i4l_1, $completion);
    return Unit_instance;
  }, 1);
}
//region block: exports
export {
  ktor_toRaw as ktor_toRaw2rfi0vr7xajpw,
  asString as asStringm4998zsa7g15,
};
//endregion

//# sourceMappingURL=JsUtils.js.mjs.map
